import React, {useEffect} from 'react';
import WtyReportHeaderRouter from "./WtyReportHeaderRouter";
import WtyReportNoAccessHeader from "./WtyReportNoAccessHeaderRouter";
import {Redirect, Route, Switch} from "react-router-dom";
import {Button, Spinner, Card} from "@deere/ux.uxframe-react";
import MachineSearch from "../machine-search/MachineSearch";
import "./WtyReportHome.css"
import ClaimSearch from "../claim-search/ClaimSearch";
import CustomerSearch from "../customer-search/CustomerSearch";
import MachineDetail from "../machine-search/MachineDetail";
import ClaimDetails from "../claim-search/ClaimDetails";
import DealerSearch from "../dealer-search/DealerSearch";
import RegionalResults from "../dealer-search/RegionalResults";
import DealerReport from "../dealer-search/DealerReport";
import DealerClaims from "../dealer-search/DealerClaims";
import {useOktaAuth} from "@okta/okta-react";
import CustomerMachines from "../machine-search/CustomerMachines";
import {useDispatch, useSelector} from "react-redux";
import {getRelatedAccounts} from "../dealer-search/DealerSlice";
import {getSecurityFeatureAccess} from "../machine-search/machineSearchSlice";
import ExpirationReport from "../expiration-report/ExpirationReport";
import { Warning, NotificationImportant } from '@mui/icons-material';
const WtyReportHome = () => {

    const dispatch = useDispatch();

    const {authState} = useOktaAuth();


    let userId, userName, firstName, lastName, userType = "";
    const name = authState?.idToken?.claims?.firstName;

    let user = {};

    const [hasApplicationAccess, setHasApplicationAccess] = React.useState(true);
    const [ApiLoaded, setApiLoaded] = React.useState(false);

    useEffect(() => {
        if (!authState?.idToken?.claims) return;
        userId = authState.idToken.claims.userID;
        userType = authState.idToken.claims.userType;
        firstName = authState.idToken.claims.firstName;

        dispatch(getSecurityFeatureAccess({userId: userId})).then(response => {
            setHasApplicationAccess(response.payload?.hasApplicationAccess ?? false);
            setApiLoaded(true);
        });

        if (userType === "Dealer Employee")
            dispatch(getRelatedAccounts({userId: userId}));


        user = {
            "userName": userId,
            "userType": userType,
            "userId": userId,
            "firstName": firstName,
            "lastName": lastName
        };
    }, [authState])
        return (
            <>
            {!ApiLoaded ? (
            <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: "100vh" }}>
            <Spinner
            accessibilityLabel="Loading"
            className="uxf-spinner-border-lg"
            animation="border"
            />
            </div>
            ) : hasApplicationAccess ? (
            <div className="app-home" style={{ minHeight: "100vh" }}>
            <WtyReportHeaderRouter userName={name}/>
            <div className="main-content">
            <Switch>
            <Route exact path="/"><MachineSearch/></Route>
            <Route exact path="/home"><MachineSearch/></Route>
            <Route exact path="/machine-search"><MachineSearch/></Route>
            <Route exact path="/machine-search/pin/:serialNumber"><MachineSearch/></Route>
            {/*<Route exact path="/machine-search/pin/details"><MachineDetail/></Route>*/}
            <Route exact path="/machine-details/pin/:serialNumber"><MachineDetail/></Route>
            <Route exact path="/machine-search/customer"><CustomerSearch/></Route>
            <Route exact path="/machine-search/customer/:customerEntityId/machines"><CustomerMachines/></Route>
            <Route exact path="/machine-search/dealer"><DealerSearch/></Route>
            <Route exact path="/dealer-search/regional-results"><RegionalResults/></Route>
            <Route exact path="/dealer/report"><DealerReport/></Route>
            <Route exact path="/dealer/claims"><DealerClaims/></Route>
            <Route exact path="/claim-search/"><ClaimSearch/></Route>
            <Route exact path="/claim-search/claimNumber"><ClaimSearch/></Route>
            <Route exact path="/claim-search/claimNumber/:claimNumber"><ClaimDetails/></Route>
            <Route exact path="/expiration-report"><ExpirationReport/></Route>
              {/*  <Route exact path="/whats-new"><WhatsNew/></Route>*/}
            <Route path="*"><Redirect to="/machine-search"/></Route>
            </Switch>
            </div>
            </div>
            ) : (
             <Card style={{ minHeight: "100vh" }}>
            <div className="page-not-found">
            <WtyReportNoAccessHeader userName={name}/>
            <div style={{ marginTop: "100px",marginBottom: "100px", textAlign: "center" }}> 
            <NotificationImportant style={{ fontSize: "48px", color: "#f57c00", marginBottom: "20px" }} />
            <h2>We have migrated to Service Center</h2>
            <p style={{ fontSize: "18px" }}>The Page you are looking for may no longer exist.</p>
            <p style={{ fontSize: "18px" }}>A new portal has been launched, designed to offer an enhanced experience. (Refer Bulletin - 
            <span 
            style={{ color: "green", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => window.open("https://dealerpath.deere.com/wps/wcm/myconnect/dpath/615b91bc-9400-48fa-b869-46219c6b0cd5/Warranty+Reports+Shutoff_30+November+2025_2.pdf?MOD=AJPERES&attachment=true&id=1758136143271", "_blank")}
            >
            068478
            </span>) </p>
            <div className="redirect-section">
            <p style={{ fontSize: "18px" }}>Click below to continue your journey:</p>
            <Button 
            href="https://servicecenter.deere.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="service-center-link" 
            variant="primary"
            style={{ borderRadius: "50px" }}
            >
            <span className="icon-service-center"></span> <b>Service Center</b>
            </Button>
            </div>
            
            <p style={{ fontSize: "18px", paddingTop: "10px" }}> <Warning style={{ fontSize: "25px", color: "#f57c00", paddingRight: "5px"}} /> Access to warranty information in Service Center is controlled by DPA access. For more details  
            <span 
            style={{ color: "blue", cursor: "pointer", textDecoration: "underline", paddingLeft: "5px" }}
            onClick={() => window.open("https://johndeere.service-now.com/now/nav/ui/classic/params/target/kb_view.do%3Fsysparm_article%3DKB0113662", "_blank")}
            >
            click here
            </span>
            </p>
            </div>
            </div>
            </Card>
            )}
            </>
        );
    };

export default WtyReportHome;
